import * as Diagram from "../../../../components/diagram";

export const CoupleElderlyLivingAloneList = {
  label: "居家環境獨居雙老清冊",
  key: "CoupleElderlyLivingAloneList",
  path: "ElderlyHealth/CoupleElderlyLivingAloneList",
  api: "TCS_V_ListOfElderlyCouplesLivingAlone",
  render: (options) => (
    <Diagram.ElderlyHealth.CoupleElderlyLivingAloneList {...options} />
  ),
  isRaw: true,
  isPage: true,
  filterColumns: [{ key: "鄉鎮", label: "照護鄉鎮", type: "string" }],
  columns: [
    {
      key: "身分證號",
      field: "身分證號",
      header: "身分證號",
    },
    {
      key: "個案名字",
      field: "個案名字",
      header: "個案名字",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "照護鄉鎮",
    },
    {
      key: "居住環境",
      field: "居住環境",
      header: "居住環境",
    },
  ],
};
